import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Wrapper = styled.div`
  @media print {
    display:block;    
  }
  display: flex;
  align-items: center;
  justify-content: space-between;

  .contentWrapper {
    text-align: left;
    flex-grow: 1;
    width: 1px;
  }
  svg {
    height: 1em;
    flex-shrink: 0;
  }
  > *:not(:last-child) {
    margin-right: ${({ theme }) => theme.spacer}px;
  }
`;

const ButtonWithIconContent = ({ className, icon, children, ellipsis }) => {
  const classes = ["ButtonWithIconContent"];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(" ")}>
      {children && (
        <div className="contentWrapper">
          <div className={ellipsis ? "ellipsis" : undefined}>{children}</div>
        </div>
      )}
      {icon}
    </Wrapper>
  );
};

ButtonWithIconContent.displayName = "ButtonWithIconContent";

ButtonWithIconContent.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  ellipsis: PropTypes.bool,
};

ButtonWithIconContent.defaultProps = {
  className: null,
  ellipsis: false,
};

export default ButtonWithIconContent;
